<template>
  <div class="serverOverview">
    <title1 type="1" title="服务器概况" subTitle="Electric Port Overview" />
    <div class="bottom">
      <div class="bottom-1">
        <div class="row1">
          <div class="title">电池堆(套)</div>
          <div class="num">{{target[0].battery_arr_number}}</div>
        </div>
        <div class="row1">
          <div class="title">电池单体数量</div>
          <div class="num">{{target[0].battery_cell_number}}</div>
        </div>
        <div class="row1">
          <div class="title">变压器</div>
          <div class="num">{{target[0].transformer}}</div>
        </div>
      </div>
      <div class="bottom-2">
        <div class="row2">
          <div class="title">额定容量(MWH)</div>
          <div class="num">{{target[0].rated_capacity}}</div>
        </div>
        <div class="row2">
          <div class="title">内存</div>
          <div class="num">{{target[0].memory_size}}</div>
        </div>
        <div class="row2">
          <div class="title">变流器</div>
          <div class="num">{{target[0].converters_number}}</div>
        </div>
      </div>
      <div class="bottom-3">
        <div class="row31">
          <div class="title">供应商</div>
          <div class="num text">{{target[0].enterprise_name}}</div>
        </div>
        <div class="row32">
          <div class="title">电池类型</div>
          <div class="num text">{{target[0].battery_type}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import title1 from "@/views/exposition/components/title1";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    title1,
  },
  data() {
    return {
      target: [
        {
          battery_arr_number: "",
        },
        {
          battery_cell_number: "",
        },
        {
          battery_type: "",
        },
        {
          rated_capacity: "",
        },
        {
          memory_size: "",
        },
        {
          converters_number: "",
        },
        {
          enterprise_name: "",
        },
        {
          transformer: "",
        }
      ],
    };
  },
  methods: {
    serverOverview() {
      let params1 = {
        "enCode": "chuneng-quanguo-fwqgl",
        "@energyId": localStorage.getItem('bigScreen::storedEnergyId') || "ES00001",
      };
      dataInterface
        .dataFaceApi(params1)
        .then((res) => {
          // console.log(params1, "params1");
          // console.log(res, "服务器概况");
           let data1 = res[0] || {}
           this.target[0].battery_arr_number=data1.battery_arr_number||1;
           this.target[0].battery_cell_number=data1.battery_cell_number||2;
           this.target[0].battery_type=data1.battery_type||3;
           this.target[0].rated_capacity=data1.rated_capacity||4;
           this.target[0].memory_size=data1.memory_size||5;
           this.target[0].converters_number=data1.converters_number||6;
           this.target[0].enterprise_name=data1.enterprise_name||7;
           this.target[0].transformer=data1.transformer||8;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  destroyed() {
		this.$bus.$off('bigScreen::storedEnergyId')
	},
	mounted() {
    this.$bus.$on('bigScreen::storedEnergyId', ()=>{
			this.serverOverview()
		})
    this.serverOverview()
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/components/energyStorage/comm.scss";

.serverOverview {
  .bottom {
    height: 276px;
    width: 565px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .bottom-1 {
      height: 84px;
      display: flex;
      justify-content: space-between;
      .row1 {
        width: 180px;
        background: rgba(255, 255, 255, 0.1);
      }
    }
    .bottom-2 {
      height: 84px;
      display: flex;
      justify-content: space-between;
      .row2 {
        width: 180px;
        background: rgba(255, 255, 255, 0.1);
      }
    }
    .bottom-3 {
      height: 84px;
      display: flex;
      justify-content: space-between;
      
      .row31 {
        width:276px;
        background: rgba(255, 255, 255, 0.1);
      }
      .row32 {
        width: 276px;
        background: rgba(255, 255, 255, 0.1);
      }
    }
    .title {
      padding-top: 8px;
      padding-left: 10px;
      font-size: 24px;
    }
    .num {
      padding-left: 10px;
      font-size: 24px;
      font-family: "HT";
      color: #00ffff;
    }
    .text{
        letter-spacing: 3px;
        font-family: 'PMZD';
      }
  }
}
</style>